export const UniCrest = ({ theme, size = 40, letterFill }) => {
  const mono = theme.monogram || "?";
  const fs = mono.length <= 2 ? 31 : mono.length === 3 ? 23 : 18;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-label={`${theme.displayName} crest`} data-testid="uni-crest">
      {theme.ornament === "cross" && (
        <g fill={theme.accentColor}>
          <rect x="29" y="3" width="6" height="16" rx="1.5" />
          <rect x="24" y="8" width="16" height="6" rx="1.5" />
        </g>
      )}
      {theme.ornament === "star7" && (
        <path
          d="M32.0,3.0 L33.5,7.8 L38.3,6.0 L35.4,10.2 L39.8,12.8 L34.7,13.2 L35.5,18.2 L32.0,14.5 L28.5,18.2 L29.3,13.2 L24.2,12.8 L28.6,10.2 L25.7,6.0 L30.5,7.8 Z"
          fill={theme.accentColor}
        />
      )}
      {theme.ornament === "tricolor" && (
        <g>
          <rect x="17" y="6" width="10" height="9" fill="#002B7F" />
          <rect x="27" y="6" width="10" height="9" fill="#FCD116" />
          <rect x="37" y="6" width="10" height="9" fill="#CE1126" />
        </g>
      )}
      <text
        x="32"
        y="53"
        textAnchor="middle"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontWeight="bold"
        fontSize={fs}
        fill={letterFill || theme.primaryColor}
      >
        {mono}
      </text>
    </svg>
  );
};
